import { render, staticRenderFns } from "./chart-associated-data.vue?vue&type=template&id=b828984c&scoped=true"
import script from "./chart-associated-data.vue?vue&type=script&lang=ts"
export * from "./chart-associated-data.vue?vue&type=script&lang=ts"
import style0 from "./chart-associated-data.scss?vue&type=style&index=0&id=b828984c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b828984c",
  null
  
)

export default component.exports